<template>
  <div class="modal-overlay" v-if="show">
    <div class="modal-content">
      <h2 v-if="step === 1">Послуги для якої з уразливих груп ви шукаєте?</h2>
      <h2 v-if="step === 2">Оберіть послуги:</h2>

      <!-- Step 1: Selecting a group -->
      <div v-if="step === 1">
        <div class="modal-radio-buttons horizontal">
          <div class="line" v-for="group in groups" :key="group.value">
            <label :for="group.value" class="group-wrapper">
              <input
                type="radio"
                :id="group.value"
                :value="group.value"
                v-model="selectedGroup"
              />
              <div class="group-text">
                <div class="group-label">{{ group.label }}</div>
                <div class="description" v-if="group.description">{{ group.description }}</div>
              </div>
            </label>
          </div>
        </div>
        <button @click="confirmGroupSelection">Підтвердити групу</button>
      </div>

      <!-- Step 2: Selecting services -->
      <div v-if="step === 2">
        <div class="checkbox-buttons">
          <div
            class="line"
            :class="{'is-disabled': isHivSelected && service.value !== 'ptv'}"
            v-for="service in filteredServices"
            :key="service.value"
          >
            <input
              type="checkbox"
              :id="service.value"
              :value="service.value"
              v-model="selectedServices"
              :disabled="isHivSelected && service.value !== 'ptv'"
              @change="onServiceChange(service.value, $event.target.checked)"
            />
            <label :for="service.value" :class="{'is-disabled': isHivSelected && service.value !== 'ptv'}">{{ service.label }}</label>
          </div>
        </div>
        <button @click="confirmSelection">Підтвердити послуги</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    preselectedGroup: {
      type: [String, Object],
      default: ''
    },
    preselectedServices: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      step: 1, // The first step is to choose a group
      selectedGroup: '', // Single selection for group
      selectedServices: [], // Multi-selection for services
      groups: [
        {
          label: 'ЛВНІ',
          value: 'PWID',
          description: 'люди, які\nвживають\nнаркотики\nін\'єкційно'
        },
        {
          label: 'СП',
          value: 'SW',
          description: 'секс-\nпрацівники'
        },
        {
          label: 'ЧСЧ',
          value: 'MSM',
          description: 'чоловіки,\nщо займаються\nсексом з чоловіками'
        }
      ],
      services: [
        { label: 'Скринінг на туберкульоз', value: 'tb_screening' },
        { label: 'Тестування на ВІЛ', value: 'ptv' },
        { label: 'Обмін та видача шприців', value: 'syringe_exchange' },
        { label: 'Розповсюдження презервативів та лубрикантів', value: 'condom_distribution' },
        { label: 'Надання цільових інформаційних, освітніх та комунікаційних послуг', value: 'information_services' }
      ]
    };
  },
  computed: {
    filteredServices() {
      if (this.selectedGroup === 'MSM') {
        return this.services.filter(service => service.value !== 'syringe_exchange');
      }
      return this.services;
    },
    isHivSelected() {
      return Array.isArray(this.selectedServices) && this.selectedServices.includes('ptv');
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.step = 1;

        this.selectedGroup =
          typeof this.preselectedGroup === 'object' && this.preselectedGroup !== null
            ? this.preselectedGroup.group
            : this.preselectedGroup;

        this.selectedServices = this.preselectedServices?.length
          ? [...this.preselectedServices]
          : [];

        // Sanitize initial state in modal
        if (Array.isArray(this.selectedServices) && this.selectedServices.includes('ptv')) {
          this.selectedServices = ['ptv'];
        } else {
          this.selectedServices = Array.from(new Set(this.selectedServices));
        }

        console.log('🔍 selectedGroup (in modal):', this.selectedGroup);
        console.log('🔍 selectedServices (in modal):', this.selectedServices);

      }
    },
    selectedServices(val, oldVal) {
      if (!Array.isArray(val)) return;
      // Dedupe while preserving order
      const uniq = Array.from(new Set(val));
      // If ptv is present, force single-select
      const next = uniq.includes('ptv') ? ['ptv'] : uniq.filter(v => v !== 'ptv');
      // Prevent infinite loop: only assign if array actually changed (length or any item differs)
      const sameLength = Array.isArray(next) && next.length === val.length;
      const sameItems = sameLength && next.every((x, i) => x === val[i]);
      if (!sameItems) {
        this.selectedServices = next;
      }
    }
  },
  methods: {
    onServiceChange(val, checked) {
      if (val === 'ptv') {
        if (checked) {
          // If HIV testing chosen: drop all others and keep only ptv
          this.selectedServices = ['ptv'];
        } else {
          // PTV unchecked: allow other services again
          this.selectedServices = this.selectedServices.filter(v => v !== 'ptv');
        }
      } else {
        // If some other was toggled while ptv is active: remove ptv
        if (this.selectedServices.includes('ptv')) {
          this.selectedServices = [];
          // Then apply only the current non-ptv toggle when it is checked
          if (checked) this.selectedServices = [val];
        } else {
          // keep deduped set for safety
          this.selectedServices = Array.from(new Set(this.selectedServices));
        }
      }
    },
    confirmGroupSelection() {
      if (this.selectedGroup) {
        this.$emit('groupSelected', {
          group: this.selectedGroup,
          services: this.selectedServices
        });
        this.step = 2; // Переходимо на наступний крок
      }
    },
    confirmSelection() {
      if (this.selectedServices.length) {
        this.$emit('confirm', { group: this.selectedGroup, services: this.selectedServices });
      }
    }
  }
};
</script>

<style scoped>
h2 {
  color: var(--col-mainblue);
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 600px;
  text-align: center;
}

/* === ВИБІР ГРУПИ === */
.modal-radio-buttons.horizontal {
  display: flex;
  justify-content: space-around;
  margin: 20px 0;
}

.modal-radio-buttons .line {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 200px;
}

.group-wrapper {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
}

/* Радіо-кнопка */
.group-wrapper input[type="radio"] {
  appearance: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid var(--col-mainblue);
  background-color: white;
  margin-top: 3px;
}

.group-wrapper input[type="radio"]:checked {
  background-color: var(--col-tab-orange);
  border-color: var(--col-mainblue);
}

/* Назва та опис */
.group-text {
  display: flex;
  flex-direction: column;
  height: 100px; /* підібрати під найвищий опис */
}

/* Назва групи (ЛВНІ, СП...) */
.group-label {
  font-weight: 600;
  font-size: 18px;
  color: var(--col-mainblue);
  margin-bottom: 4px;
  text-align: left;
}

/* Опис */
.description {
  font-size: 0.9em;
  color: var(--col-mainblue);
  white-space: pre-line;
  line-height: 1.3;
  text-align: left;
}

/* === ПОСЛУГИ === */
.checkbox-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 20px 0;
  align-items: flex-start; /* вирівнювання по лівому краю */
}

.checkbox-buttons .line {
  display: flex;
  align-items: center;
}

.checkbox-buttons input[type="checkbox"] {
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 2px solid var(--col-mainblue);
  margin-right: 10px;
  position: relative;
  background-color: white;
  cursor: pointer;
}

.checkbox-buttons input[type="checkbox"]:checked {
  background-color: var(--col-tab-orange); /* той самий помаранчевий, як у радіо */
  border-color: var(--col-mainblue);
}

.checkbox-buttons label {
  font-size: 18px;
  font-weight: 500;
  color: var(--col-mainblue);
  cursor: pointer;
  text-align: left;
}


.line.checkbox {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
}

input[type="checkbox"] {
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 2px solid var(--col-green);
  margin-right: 10px;
  position: relative;
}

input[type="checkbox"]:checked {
  background-color: var(--col-orange);
  border-color: var(--col-orange);
}

label {
  font-size: 16px;
  font-weight: 400;
}

button {
  background-color: var(--col-mainblue);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
}

/* Disabled look for non-PTV services when PTV selected */
.checkbox-buttons .line.is-disabled label,
.checkbox-buttons label.is-disabled {
  color: #9aa3ad;
  cursor: not-allowed;
  opacity: 0.65;
}
.checkbox-buttons input[disabled] {
  border-color: #c9d1d9;
  background-color: #f3f4f6;
  cursor: not-allowed;
}
</style>
